import { createContext, useState } from "react";
import { useGetContext } from "@onefront/forrestjs-react-root";

export const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
  const startOpen = useGetContext("one.layout.nav.open");
  const startHidden = useGetContext("one.layout.nav.hidden");

  const [isOpen, setIsOpen] = useState(startOpen);
  const [isHidden, setIsHidden] = useState(startHidden);

  // Deprecated
  const toggle = () => {
    console.warn(
      `"useMenu().toggle()" is deprecated, use "useMenu().toggleIsVisible()" instead`
    );
    setIsOpen((value) => !value);
  };
  const show = () => {
    console.warn(
      `"useMenu().show()" is deprecated, use "useMenu().setIsVisible()" instead`
    );
    setIsOpen(true);
  };
  const hide = () => {
    console.warn(
      `"useMenu().hide()" is deprecated, use "useMenu().setIsVisible()" instead`
    );
    setIsOpen(false);
  };

  const toggleIsVisible = () => setIsHidden((value) => !value);
  const setIsVisible = (value) => setIsHidden(!value);

  const toggleIsOpen = () => setIsOpen((value) => !value);

  return (
    <MenuContext.Provider
      value={{
        isHidden,
        isVisible: !isHidden,
        isOpen,
        toggleIsOpen,
        setIsOpen,
        toggleIsVisible,
        setIsVisible,
        toggle,
        show,
        hide
      }}
    >
      {children}
    </MenuContext.Provider>
  );
};
